'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import Image from 'next/image';
import { useSession } from 'next-auth/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { useAppContext } from '@/app/_lib/_context';

/**
 * Trade program mobile hero - 50% height 50/50 diptych
 * Content is visible below without scrolling
 */
export default function TradeHeroMobile(t0) {
  const $ = _c(25);
  const {
    slide,
    onApplyClick
  } = t0;
  const {
    openSignInModal
  } = useAppContext();
  const {
    data: session,
    status
  } = useSession();
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const isSignedIn = mounted && status === "authenticated";
  const isTradeMember = mounted && session?.user?.tradeAccount === 1;
  if (!slide) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="w-full h-full" />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== slide.mobileLeftImage.alt || $[4] !== slide.mobileLeftImage.src) {
    t3 = <div className="relative w-1/2 h-full"><Image src={slide.mobileLeftImage.src} alt={slide.mobileLeftImage.alt} fill={true} priority={true} fetchPriority="high" quality={75} sizes="(min-width: 768px) 0px, 50vw" className="object-cover object-bottom" /></div>;
    $[3] = slide.mobileLeftImage.alt;
    $[4] = slide.mobileLeftImage.src;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== slide.mobileRightImage.alt || $[7] !== slide.mobileRightImage.src) {
    t4 = <div className="relative w-1/2 h-full"><Image src={slide.mobileRightImage.src} alt={slide.mobileRightImage.alt} fill={true} priority={true} fetchPriority="high" quality={75} sizes="50vw" className="object-cover object-center" /></div>;
    $[6] = slide.mobileRightImage.alt;
    $[7] = slide.mobileRightImage.src;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="absolute inset-0 flex w-full h-full gap-0">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FontAwesomeIcon icon={faHiveIconSmallLight} className="text-xl text-primary mb-1" />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute top-36 left-[var(--site-padding)] z-10">{t6}<div className="text-lg font-light text-dark leading-tight">Trade<br />Program</div></div>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isSignedIn || $[15] !== isTradeMember || $[16] !== mounted || $[17] !== onApplyClick || $[18] !== openSignInModal) {
    t8 = mounted && (isTradeMember ? <div className="text-white text-sm">Thank you for being a trade partner</div> : <><div className="flex items-center gap-3 mb-2"><span className="text-white text-sm font-medium whitespace-nowrap">Ready to join?</span><button onClick={onApplyClick} className="btn btn-xs bg-white text-dark hover:bg-gray-5 px-4">Apply</button></div><div className="text-white text-sm">{isSignedIn ? <span>Welcome back</span> : <>Already a member?{" "}<button onClick={openSignInModal} className="underline hover:text-primary transition-colors">Login</button></>}</div></>);
    $[14] = isSignedIn;
    $[15] = isTradeMember;
    $[16] = mounted;
    $[17] = onApplyClick;
    $[18] = openSignInModal;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <div className="absolute bottom-6 right-[var(--site-padding)] z-10 text-right">{t8}</div>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t5 || $[23] !== t9) {
    t10 = <>{t5}{t7}{t9}</>;
    $[22] = t5;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}